
import Navbar from "@/components/Navbar";
import HeroSection3 from "@/components/HeroSection3";
import FeaturesSection from "@/components/landing/FeaturesSection";
import WhyLegatiaSection from "@/components/landing/WhyLegatia";
import HowItWorksSection from "@/components/landing/HowItWorksSection";
import SocialProofSection from "@/components/landing/SocialProofSection";
import FinalCTASection from "@/components/landing/FinalCTA";
import Footer from "@/components/Footer";
import BirthDateCalculator from "@/components/BirthDateCalculator";

const NewLanding = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar activePage="new" />
      <HeroSection3 />
      <FeaturesSection />
      <WhyLegatiaSection />
      <HowItWorksSection />
      <BirthDateCalculator />
      <SocialProofSection />
      <FinalCTASection />
      <Footer />
    </div>
  );
};

export default NewLanding;
